import type { StrategySkuOffer, MembershipProduct } from "./SpaceType";

/** 购买/订阅引导海报：WEB → 移动端（不含产品介绍海报） */
export function resolveProductPosterUrl(
  row: Pick<MembershipProduct, "webPurchasePosterUrl" | "mobilePurchasePosterUrl">
): string {
  return (
    (row.webPurchasePosterUrl ?? "").trim() ||
    (row.mobilePurchasePosterUrl ?? "").trim()
  );
}

export function enabledStrategySpecs(
  offers: StrategySkuOffer[] | null | undefined,
  straId: string | null
) {
  if (!straId || !offers?.length) return [];
  const hit = offers.find((o) => o.subProductItemId === straId);
  return (hit?.priceSpecs ?? []).filter((s) => s.enabled);
}

export function pickDefaultStrategyId(
  offers: StrategySkuOffer[],
  prefillStraId: string | undefined,
  entitledIds: string[]
): string | null {
  const pre = prefillStraId?.trim();
  if (pre && offers.some((o) => o.subProductItemId === pre)) {
    return pre;
  }
  const entitled = entitledIds.find((id) => offers.some((o) => o.subProductItemId === id));
  if (entitled) {
    return entitled;
  }
  return offers[0]?.subProductItemId ?? null;
}
